import axios from "../../axios";

export const getUPITxn = async (accountId, aggregated = false) => {
  try {
    const url = aggregated ? `/api/v3/aggregate/analysis/UPIAnalysis?reportReferenceId=${accountId}` : `/api/v3/analysis/UPIAnalysis?accountId=${accountId}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};
